export const WIDGET_ELEM_processRawConfigFn = (_widgetConfig) => {
  // Extract the necessary values from the raw config
  const contentType = _widgetConfig.props?.contentType;
  const measureMode = _widgetConfig.props?.measureMode || 'fieldStat';
  const metricTitle = _widgetConfig.props?.metricTitle;

  // docCount mode: just needs contentType
  if (measureMode === 'docCount') {
    if (!contentType) return _widgetConfig;

    return {
      ..._widgetConfig,
      props: {
        ..._widgetConfig.props,
        contentType,
        measureMode,
        // Documents, or the annotations on them. Configs saved before this
        // control existed were counting documents.
        countType: _widgetConfig.props?.countType || 'document',
        metricTitle
      }
    };
  }

  // fieldStat mode (default)
  const fieldObj = _widgetConfig.props?.field;
  const statFunction = _widgetConfig.props?.statFunction;
  const selectedFieldValue = _widgetConfig.props?.selectedFieldValue;
  const categoricalStatFunction = _widgetConfig.props?.categoricalStatFunction;
  const presetActiveFilters = fieldObj?.presetActiveFilters || [];
  const field = fieldObj?.valuePath;
  const isNumberInput = fieldObj?.comp === 'NumberInput';
  // A Topics field has no valuePath — it groups by its node in the clustering
  // tree (dimensionType: "topicClusteringNode"), resolved BE-side. A topic
  // DRILL also brings presetActiveFilters, narrowing the annotations counted to
  // that topic's; those are picked up above and applied by the widget.
  const isAnnoDimension = !!fieldObj?.dimensionType;

  // If essential props are missing, return config as-is
  // For NumberInput: need contentType, field, and statFunction
  // For categorical fields: need contentType, field, and selectedFieldValue
  if (!contentType || (!field && !isAnnoDimension)) {
    return _widgetConfig;
  }

  if (isNumberInput && !statFunction) {
    return _widgetConfig;
  }

  // Categorical fields need no explicit selection: an absent selectedFieldValue
  // means "every value", [] is the "please select" state ONLY once a manual mode
  // is recorded (see utils/valueSelection.js isNothingPicked — before the picker
  // existed, [] was itself how "every value" was written), and dynamic mode
  // ignores the list entirely — the widget resolves all of it at render (see
  // index.js). Returning early here used to drop presetActiveFilters for them.

  // Return processed config with all required props
  return {
    ..._widgetConfig,
    props: {
      ..._widgetConfig.props,
      contentType,
      measureMode,
      field: fieldObj,
      statFunction,
      selectedFieldValue,
      categoricalStatFunction,
      metricTitle,
      presetActiveFilters
    },
  };
};
